import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunicationService } from './logic/commumication.service';
import { RestCommunicationService } from './logic/rest-communication/rest-communication.service';
import { CommunicationDaoService } from './dao/communication-dao.service';
import { CommunicationStorageDaoService } from './dao/communication-storage-dao/communication-storage-dao.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: CommunicationService, useClass: RestCommunicationService },
    {
      provide: CommunicationDaoService,
      useClass: CommunicationStorageDaoService
    }
  ]
})
export class CommunicationModule {}
